import { Col, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { Body } from "sunday-component";
import {
  Title,
  DrawerContainer,
  HorizontalDivider,
  Submenu,
  SubmenuContainer,
} from "./SubMenuDrawer.style";

interface CustomSubMenuDrawerProps {
  visible: boolean;
  onClose: any;
}

const SubMenuDrawer = ({
  visible,
  onClose,
}: CustomSubMenuDrawerProps): JSX.Element => {
  const { t, i18n } = useTranslation("layout");
  return (
    <DrawerContainer
      closable={false}
      placement="top"
      visible={visible}
      onClose={onClose}
      height="660"
    >
      <HorizontalDivider />
      <Submenu>
        <SubmenuContainer>
          <Row>
            <Col span={7} offset={3}>
              <Title level={5}>{t("header.healthInsurance.title")}</Title>
              <ul>
                <li>
                  <a
                    href={`https://retail.easysunday.com/${i18n.language}/health`}
                  >
                    <Body level={7}>{t("header.healthInsurance.lumpSum")}</Body>
                  </a>
                </li>
                <li>
                  <a
                    href={`https://retail.easysunday.com/${i18n.language}/axa-child-health`}
                  >
                    <Body level={7}>{t("header.healthInsurance.child")}</Body>
                  </a>
                </li>
                <li>
                  <a
                    href={`https://retail.easysunday.com/${i18n.language}/#accident`}
                  >
                    <Body level={7}>
                      {t("header.healthInsurance.personalAccident")}
                    </Body>
                  </a>
                </li>
                <li>
                  <a href={`https://retail.easysunday.com/${i18n.language}`}>
                    <Body level={7}>
                      {t("header.healthInsurance.allProducts")}
                    </Body>
                  </a>
                </li>
              </ul>
              <Title level={5}>{t("header.motorInsurance.title")}</Title>
              <ul>
                {/* Due to COVID-19 situation, we hide Sunday Hero as for now...
            <li><Body level={7}><a href={`https://easysunday.com/motor/sunday-hero">{t('sundayHero')}</Body></a></li>
            */}
                <li>
                  <a
                    href={`https://retail.easysunday.com/${i18n.language}/sunday-car-insurance-ev`}
                  >
                    <Body level={7}>{t("header.motorInsurance.ev")}</Body>
                  </a>
                </li>
                <li>
                  <a
                    href={`https://retail.easysunday.com/${i18n.language}/sunday-car-insurance`}
                  >
                    <Body level={7}>{t("header.motorInsurance.motor")}</Body>
                  </a>
                </li>
                <li>
                  <a href={`https://easysunday.com/${i18n.language}/motor`}>
                    <Body level={7}>
                      {t("header.motorInsurance.allProducts")}
                    </Body>
                  </a>
                </li>
                <li>
                  <a
                    href={`https://easysunday.com/${i18n.language}/motor/claim`}
                  >
                    <Body level={7}>{t("header.motorInsurance.claim")}</Body>
                  </a>
                </li>
                <li>
                  <a
                    href={`https://easysunday.com/${i18n.language}/motor/#partnergarage`}
                  >
                    <Body level={7}>
                      {t("header.motorInsurance.sundayPartner")}
                    </Body>
                  </a>
                </li>
              </ul>
            </Col>
            <Col span={6} offset={1}>
              <Title level={5}>
                {t("header.sundayHealthForBusiness.title")}
              </Title>
              <ul>
                <li>
                  <a
                    href={`https://easysunday.com/${i18n.language}/our-product/health/`}
                  >
                    <Body level={7}>
                      {t("header.sundayHealthForBusiness.about")}
                    </Body>
                  </a>
                </li>
                <li>
                  <a
                    href={`https://easysunday.com/${i18n.language}/our-product/health/#owner`}
                  >
                    <Body level={7}>
                      {t("header.sundayHealthForBusiness.forBusinessOwner")}
                    </Body>
                  </a>
                </li>
                <li>
                  <a
                    href={`https://easysunday.com/${i18n.language}/our-product/health/#employee`}
                  >
                    <Body level={7}>
                      {t("header.sundayHealthForBusiness.forEmployee")}
                    </Body>
                  </a>
                </li>
                <li>
                  <a
                    href={`https://sundayinsurance.co.th/${i18n.language}/services/panel/?type=hospital-suncare`}
                  >
                    <Body level={7}>
                      {t(
                        "header.sundayHealthForBusiness.sundayHospitalNetwork"
                      )}
                    </Body>
                  </a>
                </li>
              </ul>
              <Title level={5}>{t("header.gadgetWarranty.title")}</Title>
              <ul>
                <li>
                  <a href={`https://easysunday.com/${i18n.language}/warranty/`}>
                    <Body level={7}>{t("header.gadgetWarranty.claim")}</Body>
                  </a>
                </li>
              </ul>
            </Col>
          </Row>
        </SubmenuContainer>
      </Submenu>
    </DrawerContainer>
  );
};

export default SubMenuDrawer;
